module.exports = __webpack_public_path__ + "img/icon6.1a912825.png";